<template src="./index.html" />
<script>
import logout from '@/mixins/Logout';
export default {
  name: 'HeaderAccountMenu',
  mixins: [logout],
  data: () => ({
    accountModal: false,
  }),
};
</script>
<style scoped lang="scss" src="./index.scss"></style>
